const state = {
  pending: false,
  orders: [],
  error: "",
  employeeOrders: [],
  customerOrders: [],
  ordersWithoutEmployee: []
};

const mutations = {
  GET_ORDERS_WITH_STATUS_PENDING(state) {
    state.pending = true;
    state.error = "";
  },
  GET_ORDERS_WITH_STATUS_SUCCESS(state, payload) {
    state.pending = false;
    state.orders = payload;
    state.error = "";
  },
  GET_ORDERS_WITH_STATUS_FAIL(state) {
    state.pending = false;
    state.error = "Wystąpił błąd, spróbuj ponownie";
  },
  SET_EMPLOYEE_ORDERS(state, payload) {
    state.employeeOrders = payload
  },
  SET_CUSTOMER_ORDERS(state, payload) {
    state.customerOrders = payload
  },
  SET_ORDERS_WITHOUT_EMPLOYEE(state, orders) {
    state.ordersWithoutEmployee = orders
  }
};

const getters = {
  getOrdersWithStatus: (state) => {
    return { orders: state.orders, pending: state.pending, error: state.error };
  },
  getEmployeeOrders: (state) => {
    return state.employeeOrders;
  },
  getCustomerOrders: (state) => {
    return state.customerOrders;
  },
  getOrdersWithoutEmployee: state => {
    return state.ordersWithoutEmployee
  }
};

export default {
  state,
  mutations,
  getters,
};
